export default __webpack_public_path__ + "static/media/AN.ddd86db0.png";